import { Link, Component } from "@mna/react";
import PageTitle from "features/PageTitle";
import { Trans } from "react-i18next";
import i18next from "i18next";
import LoadingScreen from "features/LoadingScreen";
import {
  checkAndGetLocalStorageValue,
  checkAndGetSessionStorageValue,
} from "../../../features/utils";
import { commonConstant, careOptions } from "../../../server/triage/constants";
import TriageSymptom from "../start/TriageSymptom";
import { faShieldVirus } from "@fortawesome/free-solid-svg-icons";

const confirmTitle = (
  <Trans i18nKey="findcareoption.confirm.confirm_title">
    Is this information correct?
  </Trans>
);

function editPatientConfo(state, history){
  history.push(checkAndGetLocalStorageValue("careoption") ==
  careOptions.HouseVisit
  ? `/find-care-options/house-visit`
  : checkAndGetLocalStorageValue("careoption") ==
    careOptions.Telemedicine && !state.isTravelAid2
    ? `/find-care-options/telemedicine-info`
    : careOptions.ConciergeCare && !state.IsValidUser
    ? `/find-care-options/concierge-care`
    : `/find-care-options/send-information`)
}

export default class HousevisitConfirm extends Component {
  componentDidMount() {
    const { setState, state } = this.props;
    setState({
      isLoading: false,
    });
  }
  render() {
    const { actions, history, state, setState } = this.props;
    const { triageRequest, valuedata } = state;
    if(state.isTravelAid2 && checkAndGetLocalStorageValue("IsEmergencySelected") === "false"){
    state.triageRequest.activeMenu = "start"
  }else if (checkAndGetLocalStorageValue("IsEmergencySelected") === "true") {
    state.triageRequest.activeMenu = "emergency";
  } else {
    state.triageRequest.activeMenu = "care-options";
  }
    return (
      <div className="standby-content standby-content-bottom-nav marginTop">
        <LoadingScreen isLoading={state.isLoading}>
          <article className="standby-article bottom whiteSpace">
            <div className="standby-center">
              <PageTitle titleText={confirmTitle} align="center" />
            </div>
            <div className="standby-input-info">
              <h2 className="fontWeight">
              <Trans i18nKey="findcareoption.confirm.confirm_subtitle1">
                {" "}
                Your Details:
              </Trans>
              </h2>
              <ul>
                {state.IsValidUser && triageRequest.data.username && (
                  <li> 
                    <Trans i18nKey="findcareoption.Start.Name">Name</Trans>: {triageRequest.data.username}
                  </li>
                )}

                {state.isTravelAid2 && triageRequest.data.gender === "M" && (
                  <li>
                    <Trans i18nKey="findcareoption.Start.Birthgender">Sex assigned at birth?</Trans> - <Trans i18nKey="findcareoption.Start.Male">Male</Trans>
                  </li>
                )}

                {state.isTravelAid2 && triageRequest.data.gender === "F" && (
                  <li>
                    <Trans i18nKey="findcareoption.Start.Birthgender">Sex assigned at birth?</Trans> - <Trans i18nKey="findcareoption.Start.Female">Female</Trans>
                  </li>
                )}
                {state.isTravelAid2 && checkAndGetLocalStorageValue("IsEmergencySelected") !== "true" && (
                  <li>
                    <Trans i18nKey="findcareoption.Start.DOB">What's your birthdate?</Trans> - {triageRequest.data.dateofbirth}{" "}
                  </li>
                )}

                {state.isTravelAid2 && triageRequest.data.pregnant === false && (
                  <li><Trans i18nKey="findcareoption.Start.Pregnancystatus"> Are you currently pregnant?</Trans> - <Trans i18nKey="findcareoption.No">No</Trans></li>
                )}

                {state.isTravelAid2 && triageRequest.data.pregnant === true && (
                  <li><Trans i18nKey="findcareoption.Start.Pregnancystatus"> Are you currently pregnant?</Trans> - <Trans i18nKey="findcareoption.Yes">Yes</Trans></li>
                )}

                {state.isTravelAid2 && triageRequest.data.selectChildBirth === "No" && (
                  <li><Trans i18nKey="findcareoption.Start.Childbirth"> Recent childbirth </Trans> - <Trans i18nKey="findcareoption.No">No</Trans></li>
                )}

                {state.isTravelAid2 && triageRequest.data.selectChildBirth === "Yes" && (
                  <li><Trans i18nKey="findcareoption.Start.Childbirth"> Recent childbirth </Trans> - <Trans i18nKey="findcareoption.Yes">Yes</Trans></li>
                )}
                {triageRequest.data && triageRequest.data.Height && (
                  <li>
                    <Trans i18nKey="findcareoption.Careoptions.height">Height</Trans>: {triageRequest.data.Height} cm
                  </li>
                )}
                {triageRequest.data && triageRequest.data.Weight && (
                  <li>
                    <Trans i18nKey="findcareoption.Careoptions.weight">Weight</Trans>: {triageRequest.data.Weight} lbs
                  </li>
                )}

                {triageRequest.data && triageRequest.data.phone && (
                  <li>
                    <Trans i18nKey="findcareoption.Careoptions.PhoneNumber">Phone Number</Trans>: {triageRequest.data.phone}
                  </li>
                )}
                {triageRequest.data && triageRequest.data.email && (
                  <li>
                    <Trans i18nKey="findcareoption.Careoptions.Email">Email</Trans>: {triageRequest.data.email}
                  </li>
                )}

                {triageRequest.data &&
                  triageRequest.data.extensionOrRoomNumber &&
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.Telemedicine && (
                    <li>
                      <Trans i18nKey="findcareoption.Careoptions.ExtensionRoom">Extension / Room #</Trans>: {triageRequest.data.extensionOrRoomNumber}
                    </li>
                  )}

                {state.IsValidUser ? (triageRequest.userContact === "Email" ?
                  <li>
                    <Trans i18nKey="Preferredcontact">Preferred contact method</Trans>: {i18next.t("findcareoption.Careoptions.sendinfo.Email")}
                  </li> :
                  triageRequest.userContact === "Phone" ?
                  <li>
                    <Trans i18nKey="Preferredcontact">Preferred contact method</Trans>: {i18next.t("findcareoption.Careoptions.Phone")}
                  </li> : 
                  ""
                ) : (
                  "" 
                )}

                {triageRequest.data &&
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.HouseVisit || checkAndGetLocalStorageValue("careoption") ==
                  careOptions.ConciergeCare ? (
                  triageRequest.data.locationType ===
                    commonConstant.locationTypeHouse ? (
                    <li>
                      <Trans i18nKey="findcareoption.Careoptions.housevisit.HousevisitDrpdnValue1">Location Type</Trans>: {i18next.t( "findcareoption.Careoptions.housevisit.HousevisitDrpdnValue2")}
                    </li>
                  ) : (
                    <li>
                      <Trans i18nKey="findcareoption.Careoptions.housevisit.HousevisitDrpdnValue1">Location Type</Trans>: {i18next.t("findcareoption.Careoptions.housevisit.HousevisitDrpdnValue3")}
                    </li>
                  )
                ) : (
                  ""
                )}

                {(checkAndGetLocalStorageValue("careoption") ==
                  careOptions.HouseVisit ||
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.ConciergeCare) &&
                  triageRequest.data &&
                  triageRequest.data.hotelname && (
                    <li>
                      <Trans i18nKey="findcareoption.Careoptions.HotelName">Hotel Name</Trans>: {triageRequest.data.hotelname}
                    </li>
                  )}
                {(checkAndGetLocalStorageValue("careoption") ==
                  careOptions.HouseVisit ||
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.ConciergeCare) &&
                  triageRequest.data &&
                  triageRequest.data.roomnumber && (
                    <li>
                      <Trans i18nKey="findcareoption.Careoptions.Room">Room#</Trans>: {triageRequest.data.roomnumber}
                    </li>
                  )}
                {(checkAndGetLocalStorageValue("careoption") ==
                  careOptions.HouseVisit ||
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.ConciergeCare) &&
                  triageRequest.data &&
                  triageRequest.data.roomregistered && (
                    <li>
                      <Trans i18nKey="findcareoption.Careoptions.housevisit.Roomregistered">Room registered to</Trans>: {triageRequest.data.roomregistered}
                    </li>
                  )}
                {(checkAndGetLocalStorageValue("careoption") ==
                  careOptions.HouseVisit ||
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.ConciergeCare) &&
                  triageRequest.data &&
                  triageRequest.data.location ? (
                  <li>
                    <Trans i18nKey="findcareoption.Careoptions.Address">Address</Trans>: {triageRequest.data.location}
                  </li>
                ) : (
                  <li>
                    <Trans i18nKey="findcareoption.Careoptions.Address">Address</Trans>: {checkAndGetSessionStorageValue("currentLocationName")}
                  </li>
                )}

                {triageRequest.data && triageRequest.data.insurance && (
                  <li>
                    <Trans i18nKey="userregistration.insurancecarrier">
                      Insurance carrier
                    </Trans>
                    : {triageRequest.data.insurance}
                  </li>
                )}

                {state.IsValidUser && triageRequest.data.policyNum && (
                  <li>
                    {" "}
                    <Trans i18nKey="findcareoption.Start.Policy">
                      Policy #
                    </Trans>
                    : {triageRequest.data.policyNum}
                  </li>
                )}

                {state.IsValidUser &&
                  triageRequest.data.effectFrom &&
                  triageRequest.data.effectTo && (
                    <li>
                      <Trans i18nKey="findcareoption.Start.Traveldates">
                        Travel Dates
                      </Trans>
                      : {triageRequest.data.effectFrom}
                      {" "}<Trans i18nKey="findcareoption.Start.Dateto">to</Trans>{" "}
                      {triageRequest.data.effectTo}
                    </li>
                  )}

                {(checkAndGetLocalStorageValue("careoption") ==
                  careOptions.HouseVisit ||
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.ConciergeCare) &&
                  triageRequest.data &&
                  triageRequest.data.postalCode && (
                    <li>
                      <Trans i18nKey="findcareoption.Careoptions.PostalCode">Postal Code</Trans>: {triageRequest.data.postalCode}
                    </li>
                  )}
                {(checkAndGetLocalStorageValue("careoption") ==
                  careOptions.HouseVisit ||
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.ConciergeCare) &&
                  triageRequest.data &&
                  triageRequest.data.country && (
                    <li>
                      <Trans i18nKey="findcareoption.Careoptions.country">Country</Trans>: {triageRequest.data.country}
                    </li>
                  )}
                {(checkAndGetLocalStorageValue("careoption") ==
                  careOptions.HouseVisit ||
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.ConciergeCare) &&
                  triageRequest.data &&
                  triageRequest.data.state && (
                    <li>
                      <Trans i18nKey="findcareoption.Careoptions.state">state</Trans>: {triageRequest.data.state}
                    </li>
                  )}
                {(checkAndGetLocalStorageValue("careoption") ==
                  careOptions.HouseVisit ||
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.ConciergeCare) &&
                  triageRequest.data &&
                  triageRequest.data.city && 
                  <li>
                    <Trans i18nKey="findcareoption.Careoptions.city">City</Trans>: {triageRequest.data.city}
                  </li>}

                {(checkAndGetLocalStorageValue("careoption") ==
                  careOptions.HouseVisit ||
                  checkAndGetLocalStorageValue("careoption") ==
                  careOptions.ConciergeCare) &&
                  triageRequest.data &&
                  triageRequest.data.comments && (
                    <li>
                      <Trans i18nKey="findcareoption.Careoptions.comments">Comments</Trans>: {triageRequest.data.comments}
                    </li>
                  )}

                {triageRequest.data && triageRequest.data.notes && (
                  <li><Trans i18nKey="findcareoption.Careoptions.notes">Notes</Trans>: {triageRequest.data.notes}</li>
                )}
              </ul>
              {state.IsValidUser &&
                !triageRequest.checked &&
                triageRequest.insuredInfo && (
                  <>
                    <Trans i18nKey="findcareoption.Careoptions.housevisit.primaryInsured">
                      {" "}
                      Primary Insured Details:
                    </Trans>
                    <ul>
                      {triageRequest.data && triageRequest.data.insuredOn && (
                        <li>
                          <Trans i18nKey="findcareoption.Start.Name">
                            {" "}
                            Name
                          </Trans>
                          : {triageRequest.data.insuredOn}
                        </li>
                      )}
                      {triageRequest.data &&
                        triageRequest.InsuredBirthday && (
                          <li>
                            <Trans i18nKey="findcareoption.confirm.Born">
                              {" "}
                              Born
                            </Trans>
                            : {triageRequest.InsuredBirthday}
                          </li>
                        )}
                      {triageRequest.data && triageRequest.data.sex && (
                        <li>
                          <Trans i18nKey="findcareoption.Start.Gender">
                            {" "}
                            Sex
                          </Trans>
                          : {triageRequest.data.sex === 'F' ? <Trans i18nKey="userregistration.radio-female">
                            Female
                          </Trans> : <Trans i18nKey="userregistration.radio-male">
                            Male
                          </Trans> }
                        </li>
                      )}
                      {triageRequest.data && triageRequest.data.relation && (
                        <li>
                          <Trans i18nKey="findcareoption.Careoptions.housevisit.relation">
                            {" "}
                            Relation
                          </Trans>
                          : {triageRequest.data.relation}
                        </li>
                      )}
                    </ul>
                  </>
                )}
            </div>
            <div className="standby-page-navigation standby-page-navigation-align-bottom">
              <button
                type="button"
                className="button standby-button standby-button-gradient standby-button-gradient-green"
                onClick={async () => {
                  if (state.isTravelAid2 && checkAndGetLocalStorageValue("IsEmergencySelected") !== "true") {
                    if (!state.isLoading) { setState({ isLoading: true }); }
                  }
                  var isPatientDetailsAdded = checkAndGetLocalStorageValue(
                    "isPatientDetailsAdded"
                  );
                  localStorage.setItem("phonenumber", triageRequest.data.phone);
                  if (state.IsValidUser) {
                    localStorage.setItem(
                      "username",
                      triageRequest.data.username
                    );
                    localStorage.setItem("email", triageRequest.data.email);
                  }

                  if (
                    isPatientDetailsAdded !== "" &&
                    isPatientDetailsAdded == "false"
                  ) {
                    if (
                      checkAndGetLocalStorageValue("careoption") ==
                      careOptions.HouseVisit
                    ) {
                      actions.updatePatientContact();
                      await actions.updateVendorLocation();
                      await actions.updateVendorName();
                      await actions.updateVendorContact();
                      localStorage.setItem("isPatientDetailsAdded", true);
                      gtag(
                        "set",
                        "content_group",
                        checkAndGetLocalStorageValue("orgid")
                      );
                      history.push(`/find-care-options/house-visit-result`);
                    } else if (
                      checkAndGetLocalStorageValue("careoption") ==
                      careOptions.Telemedicine
                    ) {
                      state.triageRequest.isCheckboxSelected =
                        state.triageRequest.data.consent;
                      actions.updateLogTelemedContactDetails();
                      actions.updateVendorContact();
                      actions.updatePatientContact();
                      localStorage.setItem("isPatientDetailsAdded", true);
                      gtag(
                        "set",
                        "content_group",
                        checkAndGetLocalStorageValue("orgid")
                      );
                      history.push(`/find-care-options/done`);
                    } else if (
                      checkAndGetLocalStorageValue("careoption") ==
                      careOptions.ConciergeCare
                    ) {
                      actions.updatePatientContact();
                      await actions.updateVendorLocation();
                      await actions.updateVendorName();
                      actions.updateVendorContact();
                     
                      localStorage.setItem("isPatientDetailsAdded", true);
                      history.push(`/find-care-options/concierge-care-result`);
                    }
                    else {
                      await actions.updatePatientContactForClinics();
                      gtag(
                        "set",
                        "content_group",
                        checkAndGetLocalStorageValue("orgid")
                      );
                      localStorage.setItem("isPatientDetailsAdded", true);
                      if (state.isTravelAid2 && checkAndGetLocalStorageValue("IsEmergencySelected") !== "true") {
                        await actions.updateLogTelemedContactDetails();
                        await actions.getEmergencyQuestions();
                        localStorage.setItem("isEmrgencyAnswerAdded", false);
                        localStorage.setItem("isSearchMemberAdded", false);
                        history.push('/find-care-options/symptoms')
                      }
                      else {
                        //await actions.updatePatientContactForClinics();
                        history.push(`/find-care-options/done`);
                      }
                    }
                  }
                  else {
                    if (state.isTravelAid2 && checkAndGetLocalStorageValue("IsEmergencySelected") !== "true") {
                      await actions.updatePatientContactForClinics();
                        await actions.getEmergencyQuestions();
                        localStorage.setItem("isEmrgencyAnswerAdded", false);
                        localStorage.setItem("isEmrgencyAnswerAdded", false);
                      history.push('/find-care-options/symptoms')
                    }
                    else {
                      await actions.updatePatientContactForClinics();
                      history.push(`/find-care-options/done`);
                    }
                  }
                }}
              >
                <Trans i18nKey="findcareoption.confirm.confirm">Confirm</Trans>
              </button>
              <a
                className="standby-button-back"
                href= "#"
                onClick={(e)=>{
                  editPatientConfo(state, history);
                }}
                onKeyDown={(e) => {
                  if(e.key === "Spacebar" || e.key === "Enter" || e.key === " "){
                    editPatientConfo(state, history);
                  }
                } }
              >
                <div className="icon">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 1024 1024"
                  >
                    <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
                  </svg>
                </div>
                <Trans i18nKey="findcareoption.confirm.Edit_info">
                  Edit info
                </Trans>
              </a>
              <div className="standby-page-header standby-page-header-center">
                <a
                  href="#"
                  className="standby-button-back"
                  onClick={(e) => {
                    history.push(state.triageRequest.emergency ? `/find-care-options/emergency` : state.isTravelAid2 ? `/find-care-options/location` : state.UserNavigatedToQT ? `/find-care-options/quick-telemedicine-screen` : `/find-care-options/care-options`)
                  }}
                  onKeyDown={(e) => {
                    if(e.key === " " || e.key === "Spacebar")
                    history.push(state.triageRequest.emergency ? `/find-care-options/emergency` : state.isTravelAid2 ? `/find-care-options/location` : state.UserNavigatedToQT ? `/find-care-options/quick-telemedicine-screen` : `/find-care-options/care-options`)
                  }}
                >
                  <div className="icon">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      viewBox="0 0 1024 1024"
                    >
                      <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
                    </svg>
                  </div>
                  <Trans i18nKey="findcareoption.Careoptions.telemedicine.Cancelrequest">
                    Cancel Request
                  </Trans>
                </a>
              </div>
            </div>
          </article>
        </LoadingScreen>
      </div>
    );
  }
}
